import React, { useEffect, useMemo, useState } from 'react';
import './centum-tab.css';
import { relative } from 'path';

interface Tab {
    title: string;
    // content: React.ReactNode;
}

interface TabGroup {
    title: string;
    tabs: Tab[];
}

interface TabsProps {
    tabGroups: TabGroup[];
    selectedTab: (title: string) => void;
}

function CentumTabs(props: TabsProps) {
    const { tabGroups, selectedTab } = props;

    const [activeGroupIndex, setActiveGroupIndex] = useState(tabGroups.length - 1);
    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [tempTabGroup, setTempTabGroup] = useState(tabGroups);

    const handleTabClick = (groupIndex: number, tabIndex: number, title: string) => {
        if (groupIndex === tempTabGroup.length - 1) {
            setActiveTabIndex(tabIndex);
            selectedTab(title);
            return;
        }

        const newTabGroups = [...tempTabGroup];
        const activeGroup = newTabGroups.splice(groupIndex, 1)[0];
        newTabGroups.push(activeGroup);

        setActiveGroupIndex(newTabGroups.length - 1);
        setActiveTabIndex(tabIndex);
        setTempTabGroup(newTabGroups);
        selectedTab(title);
    };

    return (
        <div className="centum-tabs">
            {tempTabGroup.map((group, groupIndex) => (
                <div key={groupIndex} className="centum-tabs__container">
                    {group.tabs.map((tab, tabIndex) => (
                        <div
                            key={tabIndex}
                            onClick={() => handleTabClick(groupIndex, tabIndex, tab.title)}
                            className={`centum-tabs__item ${activeGroupIndex === groupIndex && activeTabIndex === tabIndex ? 'active' : ''}`}>
                            {tab.title}
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export default CentumTabs;
